export const APP_TIMEZONE = 'Africa/Casablanca';
export const MAX_TEXT_LENGTH = 30;
